import { render, staticRenderFns } from "./ac.vue?vue&type=template&id=36298990"
import script from "./ac.vue?vue&type=script&lang=js"
export * from "./ac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports